import date from 'date-and-time';
import { RELEASE_ROLLOUT_WINDOW_DAYS } from 'fym-shared/src/music24/releaseRollout';
import { daysUntilRelease } from '../releaseOrder';

/**
 * What the Plan tab shows (Releases v2, designs f1, f2, f3): `release` for a release date in the
 * future or up to 7 days ago (the rollout runs from −14 to +7), `push` ("Push this song", one post
 * a week for 6 weeks) for an older release, `noDate` for a song with no release date.
 */
export type PlanMode = 'release' | 'push' | 'noDate';

export function planMode(releaseDate: string | null, now: Date): PlanMode {
  const days = daysUntilRelease(releaseDate, now);
  if (days === null) {
    return 'noDate';
  }
  return days >= -RELEASE_ROLLOUT_WINDOW_DAYS ? 'release' : 'push';
}

/** The viewer's own day as `YYYY-MM-DD`, the form of the plan days. */
export function localDay(now: Date): string {
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  return `${now.getFullYear()}-${month}-${day}`;
}

/** `day` (`YYYY-MM-DD`) plus `offset` days, as `YYYY-MM-DD` (UTC calendar days). */
export function addDays(day: string, offset: number): string {
  return date.format(date.addDays(date.parse(day.slice(0, 10), 'YYYY-MM-DD', true), offset), 'YYYY-MM-DD', true);
}
